import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent, SafePipeHTML } from './app.component';
import { HubComponent } from './hub/hub.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FaqComponent } from './faq/faq.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { RefundComponent } from './refund/refund.component';
import { ConfigService } from './config.service';

export function initializeRuntimeConfig(configService: ConfigService): () => Promise<any> {
  return (): Promise<any> => {
    return configService.initialize().toPromise();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    SafePipeHTML,
    HubComponent,
    ContactUsComponent,
    FaqComponent,
    PrivacyComponent,
    RefundComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeRuntimeConfig,
      multi: true,
      deps: [ConfigService]
    }    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
